import classnames from 'classnames'
import CarouselProjectCard from 'components/Project/CarouselProjectCard/CarouselProjectCard'
import PropTypes from 'prop-types'
import { Container, TypeHeading } from 'raspberry-pi-bits'
import React from 'react'
import { withNamespaces } from 'react-i18next'
import { Link } from 'react-router-dom'

import './UserProjectList.scss'

export const UserProjectList = ({
  isInProgress = false,
  isInFavourites = false,
  locale,
  progress,
  favourites,
  t,
  tReady,
}) => {
  const linkClassNames = (active) => {
    return classnames('c-progress-list__link', {
      'c-progress-list__link--active': active,
    })
  }

  const renderProgress = () => {
    const filtered = isInFavourites
      ? favourites
      : progress.filter((p) => p.completedInternal !== isInProgress)

    if (filtered.length === 0) {
      return (
        <TypeHeading element="h2" className="c-progress-list__no-projects">
          {isInProgress
            ? tReady && t('progress-list.no-progress')
            : isInFavourites
              ? tReady && t('progress-list.no-favourites')
              : tReady && t('progress-list.no-finished')}
        </TypeHeading>
      )
    }

    return filtered.map((p) => {
      if (('description', 'tags' in p)) {
        return (
          <CarouselProjectCard
            key={p.id}
            locale={locale}
            progress={p}
            horizontal={true}
            showProgress={isInProgress}
          />
        )
      }
      return null
    })
  }

  return (
    <Container className="c-progress-list" role="main">
      <div className="c-progress-list__nav">
        <Link
          className={linkClassNames(isInFavourites)}
          to={`/${locale}/projects/favourites`}
        >
          {tReady && t('progress-list.nav.favourites')}
        </Link>

        <Link
          className={linkClassNames(isInProgress)}
          to={`/${locale}/projects/progress`}
        >
          {tReady && t('progress-list.nav.progress')}
        </Link>

        <Link
          className={linkClassNames(!isInProgress && !isInFavourites)}
          to={`/${locale}/projects/finished`}
        >
          {tReady && t('progress-list.nav.done')}
        </Link>
      </div>
      {renderProgress()}
    </Container>
  )
}

UserProjectList.propTypes = {
  locale: PropTypes.string.isRequired,
  progress: PropTypes.array.isRequired,
  favourites: PropTypes.array.isRequired,
  isInProgress: PropTypes.bool.isRequired,
  isInFavourites: PropTypes.bool.isRequired,
  t: PropTypes.func.isRequired,
  tReady: PropTypes.bool.isRequired,
}

export default withNamespaces('translations')(UserProjectList)
